export const carreraEstudianteNormalize = (x) => ({
    idCarreraEstudiante: x.idCarreraEstudiante ?? x.IdCarreraEstudiante ?? 0,
    idCarrera: x.idCarrera ?? x.IdCarrera ?? 0,
    idEstudiante: x.idEstudiante ?? x.IdEstudiante ?? 0,
    fechaAsignacion: x.fechaAsignacion ?? x.FechaAsignacion ?? 0,
    activo: x.activo ?? x.Activo ?? true,
    certificadoGenerado: x.certificadoGenerado ?? x.CertificadoGenerado ?? false,
});
